import I18n from '../../config/locales/e_i18n';
import { call, take, put } from 'redux-saga/effects';
import { putMethod, get, post } from '../../utils/api';
import settings from '../../utils/settings';
import { getValue } from '../../utils/localStorage';
import { get as getLodash } from '../../utils/lodash';
import {
  SIGNUP_REQUEST,
  RESEND_OTP_REQUEST,
  RESEND_OTP_SUCCESS,
  RESEND_OTP_FAILURE,
  SET_PASSWORD_REQUEST,
  SET_PASSWORD_FAILURE,
  COUNTRY_LIST_REQUEST,
  COUNTRY_LIST_SUCCESS,
  COUNTRY_LIST_FAILURE,
  VALIDATE_COMPANY_REQUEST,
  VALIDATE_COMPANY_SUCCESS,
  VALIDATE_COMPANY_FAILURE
} from './constants';

export function* signUp() {
  while (true) {
    const request = yield take(SIGNUP_REQUEST);
    const { formData, successCbk = () => {}, failureCbk = () => {} } = request.payload;

    try {
      var requestOptions = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: formData
      };
      fetch(settings.getApiUrl(`service/enlm_ms/api_internal/users/signup`), requestOptions).then(function(data) {
        const { status } = data;
        data.json().then(response => {
          if (status === 200) {
            successCbk(response);
          } else {
            const errorMessage = getLodash(response, 'message') || getLodash(response, 'messages') || 'Signup Failed';
            failureCbk(errorMessage);
          }
        });
      });
    } catch (error) {
      failureCbk(error);
    }
  }
}

export function* resendRegistrationOtp() {
  while (true) {
    const request = yield take(RESEND_OTP_REQUEST);
    try {
      let response;
      const { userId } = request.payload;
      const url = settings.getApiUrl(`service/enlm_ms/api_internal/users/${userId}/resend_registration_otp`);
      response = yield call(putMethod, { url });
      if (response.success) {
        yield put({ type: RESEND_OTP_SUCCESS, message: I18n.t('registration.otpSuccess') });
      } else {
        yield put({ type: RESEND_OTP_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: resendRegistrationOtp:', error);
      yield put({ type: RESEND_OTP_FAILURE, error: error });
    }
  }
}

export function* setPassword() {
  while (true) {
    const request = yield take(SET_PASSWORD_REQUEST);
    const {
      password,
      password_confirmation,
      otp,
      userId,
      companyInfo,
      locale,
      successCbk = () => {},
      failureCbk = () => {}
    } = request.payload;
    try {
      let response;
      const url = settings.getApiUrl(`service/enlm_ms/api_internal/users/${userId}/set_password`);
      response = yield call(post, {
        url,
        body: {
          user: {
            password,
            password_confirmation,
            otp,
            locale
          },
          company: companyInfo
        }
      });
      if (response.success) {
        successCbk(response.result);
      } else {
        failureCbk(response.result.message || response.result.messages || 'Set Password Failed');
        yield put({ type: SET_PASSWORD_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: setPassword:', error);
      failureCbk(error);
      yield put({ type: SET_PASSWORD_FAILURE, error: error });
    }
  }
}

export function* getCountryList() {
  while (true) {
    yield take(COUNTRY_LIST_REQUEST);
    try {
      let response;
      const locale = getValue('locale_id') || 'en';
      response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/countries?locale=${locale}`)
      });
      if (response.success) {
        if (response.result !== []) {
          yield put({ type: COUNTRY_LIST_SUCCESS, countryList: response.result });
        } else {
          yield put({ type: COUNTRY_LIST_FAILURE, countryList: [] });
        }
      }
    } catch (error) {
      console.log('Saga: getCountryList:', error);
    }
  }
}

export function* validateCompanyData() {
  while (true) {
    const request = yield take(VALIDATE_COMPANY_REQUEST);
    try {
      let response;
      const { data } = request.payload;
      response = yield call(post, {
        url: settings.einCoreUrl(`registration/validate`),
        body: data
      });
      if (response.success) {
        yield put({ type: VALIDATE_COMPANY_SUCCESS, companyValidation: response.result });
      } else {
        yield put({ type: VALIDATE_COMPANY_FAILURE, error: response.result.message || response.result.messages });
      }
    } catch (error) {
      console.log('Saga: createAdminDetails:', error);
      yield put({ type: VALIDATE_COMPANY_FAILURE, error: error });
    }
  }
}
